import { Injectable } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SnackBarComponent} from '../../../components/snack-bar/snack-bar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {
  private readonly DURATION = 5000;

  constructor(private snackBar: MatSnackBar) { }

  public display(message: string): any {
    this.snackBar.openFromComponent(SnackBarComponent, {
      horizontalPosition: 'end',
      verticalPosition: 'top',
      duration: this.DURATION,
      data: message
    });
  }
}
